module.exports = __webpack_public_path__ + "img/boxed-3.4b674440.jpg";